<template>
  <header class="new-navbar" :class="{ open : open }" ref="header">
    <div class="new-navbar__container">
      <button class="new-navbar__hamburger" @click="openSidebar">
        <ion-icon name="menu" />
      </button>

      <h1>
        <a class="new-navbar__brand" href="/painel" title="Melhor Envio">
          <img class="icon" src="/images/svg/melhor-envio-blue.svg" alt="Logo Melhor Envio" />
        </a>
      </h1>

      <div class="new-navbar__content">
        <ul class="new-navbar__list new-navbar__list--logout">
          <li class="new-navbar__item"><a class="new-navbar__link-public" href="https://menv.io/parceiros" target="_blank">Parceiros</a></li>
          <li class="new-navbar__item"><a class="new-navbar__link-public" href="https://melhorenvio.com.br/blog" target="_blank">Blog</a></li>
          <li class="new-navbar__item">
            <a class="new-navbar__link-public" :href="$sanitizeUrl(supportPublicDashUrl)" title="Suporte">Suporte</a>
          </li>
          <li class="new-navbar__item"><a class="new-navbar__link-public" href="https://melhorrastreio.com.br/">Rastreio</a></li>
        </ul>
        <ul class="new-navbar__list new-navbar__list--logout">
          <li class="new-navbar__item"><a class="button-unbox button-unbox--primary button-unbox--alt button-unbox--compact" href="/login" title="Entrar"><span class="button-unbox__content"><span class="button-unbox__text">Entrar</span></span></a></li>
          <li class="new-navbar__item"><a class="button-unbox button-unbox--primary button-unbox--compact" href="/cadastre-se" title="Cadastrar"><span class="button-unbox__content"><span class="button-unbox__text">Cadastrar</span></span></a></li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';

  export default {
    data() {
      return {
        open : false,
        supportPublicDashUrl: ''
      }
    },
    computed: {
      ...mapGetters('general', ['sidebarOpen']),
    },
    mounted() {
      this.supportPublicDashUrl = MEConfig.get('dash.url') + '/suporte';
    },
    methods: {
      ...mapActions('general', ['changeSidebarStatus']),
      openSidebar() {
        this.changeSidebarStatus(true);
      },
    }
  }
</script>
